var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useRef, useEffect } from 'react';
import { Translate } from "../../../../../../I18N";









const EntityFilter = ({ filters, setFilters }) => {
  const filtersRef = useRef(filters);

  useEffect(() => {
    Object.entries(filters).forEach(([key]) => {
      if (filtersRef.current[key]) {
        // eslint-disable-next-line no-param-reassign
        filters[key].status = filtersRef.current[key].status;
      }
    });
    filtersRef.current = filters;
  }, [filters]);

  const handleCheckboxChange = (key, count, checked) => {
    const updatedFilters = _objectSpread(_objectSpread({},
    filtersRef.current), {}, {
      [key]: { count, status: checked } });

    filtersRef.current = updatedFilters;
    setFilters(updatedFilters);
  };

  const statusKeys = {
    new: 'New',
    processing: 'Processing',
    obsolete: 'Obsolete',
    error: 'Error',
    processed: 'Processed'
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "p-4 rounded-lg  shadow-sm" }, void 0, /*#__PURE__*/
    _jsx("h2", { className: "text-sm font-semibold font-roboto text-gray-900 mb-3" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Status")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-2" }, void 0,
    Object.entries(filters).map(([key, { count, status }]) => /*#__PURE__*/
    _jsx("label", { className: "flex items-center" }, key, /*#__PURE__*/
    _jsx("input", {
      type: "checkbox",
      checked: status || false,
      onChange: (e) => handleCheckboxChange(key, count, Boolean(e.currentTarget.checked)),
      className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" }
    ), /*#__PURE__*/
    _jsx("span", { className: "ml-3 flex flex-1 justify-between items-center text-sm text-gray-600" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-xs font-roboto" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, statusKeys[key])
    ), /*#__PURE__*/
    _jsx("div", { className: "border-b border-dashed border-gray-[#E8E7EC] mx-2 flex-grow" }), /*#__PURE__*/
    _jsx("span", { className: "text-xs font-roboto font-bold" }, void 0, count)
    )
    )
    )
    )
    )
    ));

};


export { EntityFilter };